
import './CompteClientDocCOllaborateurs.scss';

// import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import DialogValiderCollab from '../../../Components/Dialogs/DialogValiderCollab';
import { ChipRoleCollab, MaterialTableComponent, NomEmail} from '../../../Components/shared/ReusableSmallComponents';
import { StatutCollabClient } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useWindowSize from '../../../hooks/useWindowSize';
import {searchDuplicateClient, searchLabelInEnumByValue, statutCollaborateur } from '../../../Utils/utils';
import SideBar from './SideBarGestionClient';

function CollaborateursClient() {

    const [rowselected, setRowSelected] = useState();
    const axiosPrivate = useAxiosPrivate();
    const [dataCollaborateur, setdataCollaborateur] = useState([]);
    const {device}=useWindowSize();
    const [nomEntreprise, setNomEntreprise] = useState('');
    let param = useParams();
    const [open, setOpen] = useState(false);
    const location=useLocation();
    const [selectedRow, setSelectedRow] = useState(null);
    const { i18n } = useTranslation();

    useEffect(() => {
        getClientbyId();
    }, []);

    const columns = [
        {
            field: 'nom',
            title: i18n.t('Nom'),
            //enableRowSpan: true,
            render: rowData =>
                <NomEmail
                    nom={rowData?.nom}
                    email={rowData?.email_}
                    prenom={rowData?.prenom}
                />
        },
        {
            field: 'role',
            title:i18n.t('Rôle'),
            render: rowData => {
                console.log('chipp statut', rowData);
                return (
                    <>
                        <ChipRoleCollab rowSelected={rowData} />
                    </>

                );
            }
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData =>
                i18n.t(searchLabelInEnumByValue(StatutCollabClient,rowData?.statut))
        },
    ];

    useEffect(() => {
        getCollaboratorsByCompanyId();
    }, []);

    useEffect(() => {
        getClientbyId();
    }, []);

    const getClientbyId = async () => {
        try{
            let endpoint = location.pathname.includes('gestionEsn') ? '/users/getDocsEsnById/':'/users/getDocsClientById/';
            const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
            setNomEntreprise(response?.data?.profileEntreprise?.nom);
        }catch (error){
            console.log(error);
        }
    };

    const getCollaboratorsByCompanyId = async () => {
        let temp = [];
        let index;
        let colaborator;
        try {
            let endpoint = location.pathname.includes('gestionEsn') ? '/users/getCollaboratorsByEsnId/':'/users/getCollaboratorsByCompanyId/';
            const response = await axiosPrivate.get(endpoint + (param.ClientId ?? param.EsnId));
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.Comptables ?? []), temp);
            // console.log('temp temp',temp);
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.Managers ?? []), temp);
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.ResponsableAchats ?? []), temp);
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.Rhs ?? []), temp);
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.Commercials ?? []), temp);
            temp = searchDuplicateClient(response?.data?.invitations, (response?.data?.littleAdmins ?? []), temp);
            temp = searchDuplicateClient(response?.data?.invitations, [response?.data?.adminId], temp);
            // Commercials

            response?.data?.invitations.forEach(element => {
                index = temp.findIndex(object => object.email_ === element?.email);
                colaborator= element?.collaboratorData?.collaboratorId ?? element?.collaboratorData?.collaboratorEsnId;
                // console.log('emailll', element?.email, 'statut', statutCollaborateur(element?.accepted, element?.wasInvitedToJoin, element?.collaboratorData?.isActive));
                if (index === -1) {
                    temp.push({ '_id': element?._id, 'img': colaborator?.persoData?.photo, 'statut': statutCollaborateur(element?.accepted, element?.wasInvitedToJoin, element?.collaboratorData?.isActive), 'role': '', 'tele': colaborator?.persoData?.tele, 'nom': colaborator?.persoData?.nom , 'prenom': colaborator?.persoData?.prenom, 'email_': element?.email, 'nom_': colaborator?.persoData?.nom + ',' + colaborator?.persoData?.email });
                }
                //element?.wasInvitedToJoin
            });

            setdataCollaborateur(temp);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', gap: '24px' }}>
            <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')  ? i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{nomEntreprise} </span> </div>
            <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', alignSelf: 'stretch', gap: '24px' }}>
                <SideBar />

                <div className='frame0ListeCollaborateurs'>
                    <div className='frame1ListeCollaborateurs'>
                        <h5
                            className='frame2ListeCollaborateurs'
                        >{i18n.t('Liste des Collaborateurs')}</h5>
                    </div>
                    <MaterialTableComponent
                        data={dataCollaborateur}
                        columns={columns}
                        title={i18n.t('Liste des Collaborateurs')}
                        onRowClick={(event, rowData) => {
                            setSelectedRow(rowData?.tableData.id);
                            setRowSelected(rowData);
                            setOpen(true);
                        }}
                        selectedRow={selectedRow}
                    />
                    {open &&
                    <DialogValiderCollab
                        open={open}
                        setOpen={() => {
                            setOpen(false);
                            getCollaboratorsByCompanyId();
                        }}
                        rowSelected={rowselected}
                    />}
                </div>
            </div>
        </div>
    );
}
export default CollaborateursClient;